import { RemoteShellBaseDataProvider } from './RemoteShellBaseDataProvider';

export class RemoteShellNirvanaDataProvider extends RemoteShellBaseDataProvider {
  async getAuthenticationSettings(companyId) {
    return this.dependencies.api.clients.Company.getAuthenticationSettings(companyId).toPromise();
  }
}
